import { render, staticRenderFns } from "./TerminosView.vue?vue&type=template&id=64d87428&scoped=true&"
import script from "./TerminosView.vue?vue&type=script&lang=ts&"
export * from "./TerminosView.vue?vue&type=script&lang=ts&"
import style0 from "./TerminosView.vue?vue&type=style&index=0&id=64d87428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d87428",
  null
  
)

export default component.exports